// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"297":"2e80c31ad005ff9b266c","491":"9cfd7b43ce83eb5293ea","945":"12aad671dde769b41a8d","959":"56e893e0044615791881"}[chunkId] + ".chunk.js";
};